import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import TextCell from "./Text";
import TextTwoValuesCell from "./TextTwoValues";
import AvatarCell from "./Avatar";
import DateCell from "./Time";
import CurrencyCell from "./Currency";
import ValuePercentageCell from "./ValuePercentage/index";
import PercentageCell from "./Percentage";
import BooleanCell from "./Flag";
import NumberCell from "./Digit";
import ToggleCell from "./Toggle";
const cells = {
  textCell: TextCell,
  textTwoValuesCell: TextTwoValuesCell,
  avatarCell: AvatarCell,
  dateCell: DateCell,
  currencyCell: CurrencyCell,
  valuePercentageCell: ValuePercentageCell,
  percentageCell: PercentageCell,
  booleanCell: BooleanCell,
  numberCell: NumberCell,
  toggleCell: ToggleCell
};
export default function Children(params) {
  const newParams = _objectSpread(_objectSpread(_objectSpread({}, params), params.childrenParams), {}, {
    value: params.childrenParams.field && params.data[params.childrenParams.field]
  });
  const newCell = params.childrenParams.cellRenderer && cells[params.childrenParams.cellRenderer];
  return newCell(newParams);
}